import { attachDialog } from '../../util/dialog_helpers.js';
import { attachEventHandlers } from '../mixins/ConfirmKoreanBrowseFontsDialog.js';

/**
 * Show the Korean Browse Fonts dialog
 */
export const showKoreanBrowseFontsDialog = async () => {
  try {
    const response = await fetch('/shared/dialogs/korean_browse_fonts_dialog');
    if (!response.ok) {
      console.error('Failed to fetch dialog template:', response.status, response.statusText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const template = await response.text();
    const dialog = attachDialog(template);

    attachEventHandlers(dialog);
  } catch (error) {
    console.error('Error fetching dialog template:', error);
  }
};
